import { S144gS144m01Component } from './s144g-s144m01.component';

export { S144gModule } from './s144g.module';

export const S144gSubComponentsMap = {
	
};

export const S144gComponentsMap = {
	"s144g-s144m01": S144gS144m01Component
};

export const S144gComponents = [
	S144gS144m01Component
];

